import { useFormContext } from 'react-hook-form';
import { Box } from '@mui/material';
import { FormCheckbox, LwFormDate } from 'redesign';
import { FilterCreationDateFormContext } from './filter-creation-date.types';

export const FilterCreationDate = () => {
  const { watch, control } = useFormContext<FilterCreationDateFormContext>();
  const { allowCreationDateFilter } = watch();

  return (
    <Box>
      <FormCheckbox
        name="allowCreationDateFilter"
        label="Aanmaak datum"
        control={control}
        isHeaderCheckbox={true}
      />
      {allowCreationDateFilter ? (
        <Box paddingLeft="30px">
          <LwFormDate
            name="creationDate"
            label="Aanmaak datum"
            control={control}
            rules={{ required: false }}
            data-testid="creation-date"
          />
        </Box>
      ) : null}
    </Box>
  );
};
